import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DatePickerPopoverPage } from './date-picker-popover';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";
import {DatePickerModule} from "ion-datepicker";
import {CalendarModule} from "ion2-calendar";

@NgModule({
  declarations: [
    DatePickerPopoverPage,
  ],
  imports: [
    IonicPageModule.forChild(DatePickerPopoverPage),
    PipesModule,
    DirectivesModule,

    CalendarModule,
  ],
})
export class DatePickerPopoverPageModule {}



// WEBPACK FOOTER //
// ./src/pages/date-picker-popover/date-picker-popover.module.ts